module.exports = __webpack_public_path__ + "static/img/gj.80cbb02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gj.jpg
// module id = voBm
// module chunks = 1